/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, Input, ViewChild } from '@angular/core';
import { SysqueTabModel } from '../../models/sysque-tab-model';
import { DxTabPanelComponent } from 'devextreme-angular';

@Component({
  selector: 'sysque-tab',
  templateUrl: './sysque-tab.component.html',
  styleUrls: ['./sysque-tab.component.scss'],
  standalone: false
})
export class SysqueTabComponent {
  @Input() content: SysqueTabModel[] = [];
  @Input() titleClick: Function;
  @ViewChild('dxTabPanel') dxTabPanel: DxTabPanelComponent;
  
}
